import { Component, OnInit, ViewChild, ViewContainerRef, NgModule, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppComponent } from '../../app.component';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { SelectMultiResourceMainComponent } from './select-multi-resource-main.component';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { SelectMultiResourceService } from '../../service/select-multi-resource.service';
import { DisplayService } from '../../service/display.service';
import { CustomViewService } from '../../service/custom-view.service';
import { TokenManager } from '../../service/web-api.service';
import { AuthService } from '../../service/auth.service';
import { environment } from '../../../environments/environment';
import { isError } from 'util';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-select-multi-resource',
  templateUrl: './select-multi-resource.component.html',
  providers: [SelectMultiResourceService, DisplayService, CustomViewService]
})

export class SelectMultiResourceComponent implements OnInit {

  // 画面ID
  readonly SCREEN_ID = 'O07';

  /** リソース一覧を求めているクライアント名 */
  public clientName: string;
  /** タイトルロゴ */
  public dispZ0001: string;
  /**エラーメッセージ */
  public messages: any[];

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: SelectMultiResourceMainComponent;
  // テンプレートファイ名（HTML）
  public templateHtml: string;
  // テンプレートファイル（CSS）
  public templateCss: string;
  // 画面資材ルートURL
  public assetsBaseUrl: string;
  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // 選択された親リソース
  public selectedParentResource: any;

  // 子リソース表示区分コード（単体：'1' 複数：'2'）
  public accountSelectCode: string;

  // 認可済み子リソース選択状態
  public childResourceSelectMode: string;

  // 勘定系エラーフラグ
  public isError: boolean;

  // 勘定系エラーコード
  public errorCode: string;

  // 勘定系エラーメッセージ
  public errorMessage: string;

  // サービス名
  public serviceName: string;

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;

  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  constructor(
    public router: Router,
    private displayService: DisplayService,
    private selectMultiResourceService: SelectMultiResourceService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private customViewService: CustomViewService,
    private compiler: Compiler,
    public translateService: TranslateService) { }

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }
    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/select-multi-resource/' + this.serviceName + '_select-multi-resource';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_select-multi-resource.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
      }

      this.clientName = data.clientName;

      this.selectMultiResourceService.execResourceInfoList().subscribe(
        result => {
          this.selectedParentResource = result.resourceInfoList[0];
          this.accountSelectCode = result.accountSelectCode;
          this.childResourceSelectMode = result.childResourceSelectMode;

          // 一覧取得エラー時
          this.isError = !result.result;
          this.errorCode = result.errorCode;
          this.errorMessage = result.errorMessage;

          // カスタムページ表示
          this.directInjection();
        },
        error => {
          this.router.navigate(['/error', error.status]);
        }
      );
    });

    this.messages = [];
  }

  /**
   * コンポーネントを生成し親コンポーネントに挿入する
   *
   */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/select-multi-resource/' + this.serviceName + '_select-multi-resource' + '/' + this.pageNo,
      'page_title': 'select_multi-resource',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'select_multi-resource',
      'page_location': this.serviceName + '/select-multi-resource/' + this.pageNo
    });


    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    let templateHtmlText;
    if (!this.isError) {
      templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    } else {
      templateHtmlText = await this.customViewService.getText(this.templateHtml + '_error.html').toPromise();
    }
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);

    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-select-multi-resource-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class SelectMultiResourceModuleComponent extends SelectMultiResourceMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [SelectMultiResourceModuleComponent],
      exports: [SelectMultiResourceModuleComponent]
    })
    class SelectMultiResourceModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(SelectMultiResourceModule);
    // Angular モジュールから SelectMultiResourceModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === SelectMultiResourceModuleComponent;
    });

    // SelectMultiResourceModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<SelectMultiResourceModuleComponent>componentRef.instance);
    this.comp.init(this, this.selectMultiResourceService, this.waitModal, this.confirmModal);
  }

}
